import { useState } from 'react';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host

export const TracksWeb = () => {
   const [chevron, setChevron] = useState(0);
   const [margin1, setMargin1] = useState("0vw");

   const tracks = [
      {
         name: "TECH",
         icon: "./assets/media/fluent_power-28-regular.png",
         background: "url('./assets/media/unsplash_Bd7gNnWJBkU.png')",
         list: [
            "mobile",
            "internet/digital marketing",
            "IoT",
            "security",
            "software/IT",
            "edtech",
            "robotics",
         ],
      },
      {
         name: "FINTECH",
         icon: "./assets/media/clarity_bank-line.png",
         background: "url('./assets/media/unsplash_JrjhtBJ-pGU.png')",
         list: [
            "banking",
            "blockchain",
            "insurtech",
            "personal finance",
            "payments",
            "predictive analytics"
         ],
      },
      {
         name: "CLEANTECH",
         icon: "./assets/media/Vector.png",
         background: "url('./assets/media/unsplash_xG79esLZJ7U.png')",
         list: [
            "energy efficiency",
            "energy generation",
            "energy infrastructure",
            "energy storage",
            "transportation",
            "water & wastewater",
            "agritech"
         ],
      },
      {
         name: "MEDTECH",
         icon: "./assets/media/Vector (1).png",
         background: "url('./assets/media/unsplash_7wWRXewYCH4.png')",
         list: [
            "medical devices",
            "diagnostics",
            "monitoring",
            "wearables",
            "AI solutions",
            "medical AR",
         ],
      },
      {
         name: "LIFESCIENCES & HEALTHCARE",
         icon: "./assets/media/Vector (2).png",
         background: "url('./assets/media/unsplash_UIp163xCV6w.png')",
         list: [
            "biotech",
            "drug discovery",
            "healthcare IT",
            "pharma",
            "healthcare",
         ],
      },
   ];
   return (
      <div
         className="gradient"
         style={{
            backgroundColor: "#212529",
            display: "flex",
            flexDirection: "column",
         }}
      >
         {/* <img style={{ width: "100%" }} src={window.innerWidth < 769 ? "./assets/media/Component 30.png" : "./assets/media/Frame 159.png"} /> */}
         <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center', gap: '15px', padding: '2.5%' }}>
            <h1 style={{ width: '100%', textAlign: 'center', fontWeight: '900', color: "#7C2387", fontSize: "3rem" }}>CALL FOR TOP INNOVATORS!</h1>
            <h4 style={{ width: '100%', textAlign: 'center', fontWeight: '900', color: 'black' }}>Get Noticed <span style={{ color: "#7C2387" }}>»</span> Get Funded <span style={{ color: "#7C2387" }}>»</span> Grow Faster</h4>
            <h5 style={{ width: window.innerWidth < 769 ? "100%" : '50%', textAlign: 'center', margin: 'auto', color: 'black' }}>A select group of more than <b>100 Top Innovators</b> from the following sectors will be chosen to present their breakthrough investment opportunities to an exclusive audience of <b>Venture Capitalists, Corporate Investors, Private Investors, Investment Bankers, and Strategic Partners.</b></h5>
         </div>
         <div style={{ display: "flex", padding: "0% 10%", alignItems: "stretch", gap: window.innerWidth < 1000 ? '15px' : '5%', justifyContent: 'center', flexDirection: window.innerWidth < 1000 ? "column" : "row" }}>
            {tracks.map((track, i) => {
               return (
                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: track.background,
                        backgroundSize: "100% 100%",
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: "1%",
                        flex: "1 1 0px",
                        borderRadius: '5px'
                        // flexBasis:'100%'
                     }}
                  >
                     <img alt='track' src={track.icon} style={{ maxWidth: '250px', margin: 'auto', marginBottom: '1%' }} />
                     <h4 style={{ textAlign: 'center', color: 'white' }}>{track.name}</h4>
                     <List sx={{ color: "white", flex: 1.5 }}>
                        {track.list.map((item, i) => {
                           if (i === 0 || i === track.list.map.length - 1) {
                              return <ListItem sx={{ textAlign: 'center', justifyContent: 'center' }}>{item}</ListItem>;
                           } else {
                              return (
                                 <>
                                    <Divider sx={{ background: "white" }} />
                                    <ListItem sx={{ textAlign: 'center', justifyContent: 'center' }}>{item}</ListItem>
                                 </>
                              );
                           }
                        })}
                     </List>
                  </div>
               );
            })}
         </div>
         <a href={`https://youngstartup.com/upcoming`} style={{ margin: 'auto', marginTop: '2.5%', marginBottom: '2.5%' }}>
            <Button
               onMouseOver={(e) => {
                  setChevron(1);
                  setMargin1("1.5vw");
               }}
               onMouseLeave={() => {
                  setChevron(0);
                  setMargin1("0vw");
               }}
               className="dark-btn"
               sx={{ fontWeight: "900", fontSize: '1.25rem', color: "white !important", backgroundColor: '#7C2387 !important', "&:hover": { backgroundColor: '#7C2387 !important', color: "white !important" } }}

            >
               <div style={{ display: "flex", alignItems: 'center' }}>
                  <ChevronRightIcon sx={{ opacity: "0" }} />
                  <div>Apply Now</div>
                  <ChevronRightIcon
                     sx={{
                        transition: ".3s all ease-in-out",
                        opacity: chevron,
                        marginLeft: margin1,
                     }}
                  />
               </div>
            </Button>
         </a>
      </div>
   );
};
